import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';

import { RowRenderer } from '../../Common/rowRenderer';
import { DateFormatter } from '../../Common/dateFormat';
import BalanceCellFormatter from './BalanceCellFormatter';
import CashFormatter from '../../Common/cashFormatter';


class APReceiveTable extends Component {
  state = {
    rows: [],
    sortColumn: null,
    sortDirection: null,
  };

  componentDidMount() {
    if (this.props.rows) {
      const { rows } = this.props;
      this.setState({ rows });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.rows !== this.props.rows) {
      const { rows } = nextProps;
      this.setState({ rows });
    }
  }

  getRows = () => Data.Selectors.getRows(this.state);

  getSize = () => this.getRows().length;

  rowGetter = (rowIdx) => {
    const rows = this.getRows();
    return rows[rowIdx];
  }

  handleGridSort = (sortColumn, sortDirection) => {
    this.setState({
      rows: this.getRows(),
      sortColumn,
      sortDirection,
     });
  }

  handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {
    const rows = this.getRows();

    for (let i = fromRow; i <= toRow; i++) {
      const rowToUpdate = rows[i];
      const updatedRow = { ...rowToUpdate, ...updated };
      rows[i] = updatedRow;
    }
    if (this.props.from === 'selectedInvoices') {
      this.setState({ rows });
      this.props.handleCellUpdate(rows);
    }
  }

  render() {
    const columns = [
      {
          key: 'ReceiveNum',
          name: <Translate value="receive_num" />,
          resizable: true,
          sortable: true,
          filterable: true
      },
      {
          key: 'InvoiceNum',
          name: <Translate value="invoice_no" />,
          resizable: true,
          sortable: true,
          filterable: true
      },
      {
          key: 'PostingDate',
          name: <Translate value="receive" />,
          resizable: true,
          sortable: true,
          filterable: true,
          formatter: DateFormatter
      },
      {
          key: 'Amount',
          name: <Translate value="amount" />,
          resizable: true,
          sortable: true,
          filterable: true,
          formatter: CashFormatter,
      },
      {
          key: 'UnpaidAmount',
          name: <Translate value="balance" />,
          resizable: true,
          sortable: true,
          filterable: true,
          formatter:
            <BalanceCellFormatter>
              <CashFormatter />
            </BalanceCellFormatter>,
          getRowMetaData: (row) => row,
      },
    ];

    const { moveInvoices, from, to } = this.props;
    if (from === 'selectedInvoices') {
      const column = {
          key: 'DiscountedAmount',
          name: <Translate value="discount" />,
          resizable: true,
          filterable: true,
          editable: true,
          formatter: CashFormatter,
      };
      columns.splice(4, 0, column);
    }
    return (
      <div style={{ maxWidth: '100%' }} id="APReceiveTable-dataGrid1">
        <ReactDataGrid
          enableCellSelect
          rowRenderer={
            <RowRenderer
              onDoubleClick={moveInvoices}
              from={from}
              to={to}
            />
          }
          onGridSort={this.handleGridSort}
          columns={columns}
          rowHeight={25}
          minHeight={390}
          rowGetter={this.rowGetter}
          rowsCount={this.getSize()}
          onGridRowsUpdated={this.handleGridRowsUpdated}
        />
      </div>
    );
  }
}

export default APReceiveTable;



// WEBPACK FOOTER //
// ./master/jsx/components/AP/CreateAP/apReceiveTable.jsx